import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { flyerAPI } from "api/Interactions/FlyersAPI";

interface AddFlyersPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newFlyers: any) => void;
}

const AddFlyersPopup: React.FC<AddFlyersPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Flyers"
      createFunction={flyerAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description" },
        { name: "linked_campaign", label: "Campaign", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddFlyersPopup;
